import * as types from "./types";

export const fetchingUsageLogs = () => ({
  type: types.FETCHING_USAGE_LOGS,
  loading: true
});

export const deletingUsageLog = () => ({
  type: types.DELETING_USAGE_LOG,
  loading: true
});

export const addingUsageLog = () => ({
  type: types.ADDING_USAGE_LOG,
  loading: true
});

export const addedUsageLog = (usage_log) => ({
  type: types.ADDED_USAGE_LOG,
  usage_log: usage_log,
  loading: false
});

export const deletedUsageLog = (usage_log) => ({
  type: types.DELETED_USAGE_LOG,
  usage_log: usage_log,
  loading: false
});

export const fetchedUsageLogs=(usage_logs, productId)=>({
  type: types.FETCHED_USAGE_LOGS,
  usage_logs: usage_logs,
  productId: productId,
  loading: false
});

export const errorFetchingUsageLogs = (error) => ({
  type: types.ERROR_FETCHING_USAGE_LOGS,
  error: error,
  loading: false
});

export const errorAddingUsageLog = (error) => ({
  type: types.ERROR_ADD_USAGE_LOG,
  error: error,
  loading: false
});

export const errorDeletingUsageLog = (error) => ({
  type: types.ERROR_DELETING_USAGE_LOG,
  error: error,
  loading: false
});